"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkClientMapCacheProvider = exports.NetworkClientNoopCacheProvider = void 0;
class NetworkClientNoopCacheProvider {
    getOrCalculate(key, callback) {
        return callback();
    }
}
exports.NetworkClientNoopCacheProvider = NetworkClientNoopCacheProvider;
class NetworkClientMapCacheProvider {
    constructor() {
        this.map = new Map();
    }
    async getOrCalculate(key, callback) {
        if (this.map.has(key)) {
            return this.map.get(key);
        }
        else {
            const value = await callback();
            this.map.set(key, value);
            return value;
        }
    }
}
exports.NetworkClientMapCacheProvider = NetworkClientMapCacheProvider;
